import Decimal from 'decimal.js';
import { NUMBERS_TO_POSITIONS } from 'lib/constants/number';

export function getRandomInt(max: number): number {
    return Math.floor(Math.random() * max);
}

export const countDigits = (value: number): number => value.toString().split('.')[1]?.length || 0;

export const replaceDotWithComaAsDecimalSeparator = (value: number | string): string => {
    const stringifiedValue = typeof value === 'string' ? value : value.toString();
    return stringifiedValue.replace('.', ',');
};

export const roundToNearestIntegrer = (value: number | string): number => {
    const numericValue = typeof value === 'number' ? value : parseFloat(value);

    if (numericValue < 0 || numericValue > 0) {
        return Math.floor(numericValue);
    } else {
        return 0;
    }
};

export const roundDecimalsToNearestCent = (value: number | string, toNearestIntegrer?: boolean): number => {
    const decimalValue = new Decimal(typeof value === 'number' ? value : parseFloat(value));
    const roundedValue = decimalValue.toDecimalPlaces(2, Decimal.ROUND_UP).toString();

    if (toNearestIntegrer) {
        return roundToNearestIntegrer(roundedValue);
    }

    return parseFloat(roundedValue);
};

export const numberToPosition = (value: number): string => NUMBERS_TO_POSITIONS[value] || `${value}-th`;
